import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { MonthAndYearPipe } from '@platform-frontend/transloco';
import { map, Observable, of } from 'rxjs';
import { LicenseValidityGranularity } from '../model/license-validity-context';

@Pipe({
  name: 'licenseValidityDate'
})
export class LicenseValidityDatePipe implements PipeTransform {
  constructor(private translocoLocaleService: TranslocoLocaleService) {}

  transform(value: Date | null, granularity: LicenseValidityGranularity): Observable<string> {
    return value === null
      ? of('')
      : granularity === 'MONTH'
      ? new MonthAndYearPipe(this.translocoLocaleService).transform(value)
      : this.translocoLocaleService.localeChanges$.pipe(map(locale => this.getDateFromLocaleAndGranularity(value, locale, granularity) ?? ''));
  }

  private getDateFromLocaleAndGranularity(date: Date, locale: string, granularity: Omit<LicenseValidityGranularity, 'MONTH'>): string | null {
    switch (granularity) {
      case 'DATE':
        return this.translocoLocaleService.localizeDate(date, locale, { dateStyle: 'medium' });
      case 'DATE_TIME':
        return this.translocoLocaleService.localizeDate(date, locale, { dateStyle: 'medium', timeStyle: 'short' });
    }
    return null;
  }
}
